import React, { useState } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const IndustrySelector = (props) => {
  const [IncludedIndustries, setIncludedIndustries] = useState(
    require("../resources/industries.json")
  );

  const [count, setCount] = useState(0);

  const handleIncludedIndustryCheckBoxChange = (event, index) => {
    setCount(count + 1);
    const tempIncludedIndustries = IncludedIndustries;
    tempIncludedIndustries[index].checked = event.target.checked;
    setIncludedIndustries(tempIncludedIndustries);
    const selectedOptions = tempIncludedIndustries.filter(
      (title) => title.checked
    );
    props.onChange(selectedOptions);
  };

  return (
    <div>
      <div>
        <p>(Leave blank to query all industries.)</p>
        <p style={{ color: "#FFFFFF" }}>{count}</p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        {IncludedIndustries.map((item, index) => (
          <div
            key={String(Math.random())}
            style={{ width: 250, marginRight: 10 }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={IncludedIndustries[index].checked}
                  onChange={(e) =>
                    handleIncludedIndustryCheckBoxChange(e, index)
                  }
                  value={item.label}
                  name="includedIndustries"
                  color="primary"
                  id="incl"
                />
              }
              label={item.label}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndustrySelector;
